import React, { useEffect } from 'react';
import axios from 'axios';
import {
  List, Box, Typography, Select, MenuItem, BottomNavigation, BottomNavigationAction, TableContainer, Table, TableHead,Input,
  TableBody, TableRow, Paper, Pagination, Snackbar, Alert,Button
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import globalStyles from '../../utils/globalStyles';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import legolasApi from '../../api/legolas';
import uilityApi from '../../api/utility';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from '@mui/icons-material/Search';

import moment from 'moment';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function CorporateGifting() {
  const [totalCount, setTotalCount] = React.useState(0);
  const [listData, setListData] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [exportDisble, setExportDisable] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [selectDate, setSelectDate] = React.useState({ fromDate: null, toDate: null });
  const [searchString, setSearchString] = React.useState("");

  const [allTableHeaders, setAllTableHeaders] = React.useState([
    { id: "fullName", label: "Full Name", checked: true },
    { id: "company", label: "Company", checked: true },
    { id: "typeOfGifting", label: "Type of Gifting", checked: true },
    { id: "email", label: "Email", checked: true },
    { id: "phone", label: "Phone", checked: true },
    { id: "country", label: "Country", checked: true },
    { id: "city", label: "City", checked: true },
    { id: "totalGiftNeeded", label: "Total Gifts Needed", checked: true },
    { id: "approxTotalBudget", label: "Approx. Budget", checked: true },
    { id: "eventDate", label: "Event Date", checked: true },
    { id: "createdAt", label: "Created At", checked: true },
  ]);

  // Fetch gifting enquiries whenever filter/search/page changes
  React.useEffect(() => {
    fetchCorporateGifts(currentPage);
  }, [currentPage, selectDate, searchString]);

  const fetchCorporateGifts = (page) => {
  const params = {
    page,
    fromDate: selectDate.fromDate
      ? new Date(selectDate.fromDate).toISOString()
      : "",
    toDate: selectDate.toDate
      ? new Date(selectDate.toDate).toISOString()
      : "",
    search: searchString || "",
  };

  axios
    .post(`${legolasApi.url}/admin/gift/corporateGift/list`, params)
    .then((res) => {
      if (res.data.success) {
        setListData(res.data.data);
        setTotalCount(res.data.count);
      }
    })
    .catch((error) => {
      console.error("Error fetching corporate gifts:", error);
    });
};


  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    return d.toLocaleDateString("default", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handlePagination = (event, value) => {
    setCurrentPage(value);
  };

  const handleFromDateChange = (date) => {
    setSelectDate((prev) => ({ ...prev, fromDate: date }));
    setCurrentPage(1); // reset pagination
  };

  const handleToDateChange = (date) => {
    setSelectDate((prev) => ({ ...prev, toDate: date }));
    setCurrentPage(1);
  };

  const handleSearch = () => {
    setCurrentPage(1); // reset pagination
  };

  const handleExport = () => {
  setExportDisable(true);
  setShowLoader(true);

  const params = {
    fromDate: selectDate.fromDate
      ? new Date(selectDate.fromDate).toISOString()
      : "",
    toDate: selectDate.toDate
      ? new Date(selectDate.toDate).toISOString()
      : "",
    search: searchString || "",
    exportAll: true, // fetch all data ignoring pagination
  };

  axios
    .post(`${legolasApi.url}/admin/gift/corporateGift/list`, params)
    .then((res) => {
      if (!res.data.success || !res.data.data) {
        throw new Error("No data available to export");
      }

      const exportData = res.data.data;
      const headers = Object.keys(exportData[0] || {});
      const csvContent = [
        headers.join(","),
        ...exportData.map((row) =>
          headers
            .map((key) => {
              const cell = row[key];
              if (cell === null || cell === undefined) return "";
              if (typeof cell === "string" && cell.includes(",")) {
                return `"${cell}"`;
              }
              return cell.toString().trim();
            })
            .join(",")
        ),
      ].join("\r\n");

      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      const fileName =
        "corporate_gifting_export_" + new Date().getTime() + ".csv";
      link.setAttribute("href", window.URL.createObjectURL(blob));
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setExportDisable(false);
      setShowLoader(false);
    })
    .catch((error) => {
      setShowLoader(false);
      setExportDisable(false);
      console.error("Error in exporting corporate gifting data: ", error);
    });
};


  return (
    <React.Fragment>
      <Box sx={{ margin: "0px", padding: "0px" }}>
        <List actions={null}>
           <Box sx={globalStyles.headerWrapperBox}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                margin: "0px 30px",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="h4">Corporate Gifting</Typography>
                <Typography
                  variant="subtitle1"
                  sx={globalStyles.headerCountSubtitle}
                >
                  {totalCount} record(s) found
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{
            width: '100%',
            display: 'flex',
            margin: '0px 30px',
            '& .MuiInput-input': {
              width: '375px !important',
              padding: '5px 10px !important'
            },
            '& .MuiSvgIcon-root': {
              paddingRight: '10px'
            },
            justifyContent: 'space-between'
          }}>
            <Input
                type="search"
                sx={{
                  border: "1px solid #2b3f7a",
                  borderRadius: "20px",
                  marginTop: "25px",
                }}
                endAdornment={
                  <SearchIcon sx={{ cursor: "pointer" }} onClick={handleSearch} />
                }
                placeholder="Search by ID, Email, Phone"
                onChange={(e) => setSearchString(e.target.value)}
              />
              
 <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  marginRight: "690px",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ marginBottom: "2px", fontSize: "14px", color: "rgb(128,128,128)" }}
                >
                  Filter by Date Range
                </Typography>
                <Box sx={{ display: "flex", gap: "7px" }}>
                  <DatePicker
                    selected={selectDate.fromDate}
                    onChange={handleFromDateChange}
                    selectsStart
                    startDate={selectDate.fromDate}
                    endDate={selectDate.toDate}
                    isClearable
                    placeholderText="From Date"
                  />
                  <DatePicker
                    selected={selectDate.toDate}
                    onChange={handleToDateChange}
                    selectsEnd
                    startDate={selectDate.fromDate}
                    endDate={selectDate.toDate}
                    minDate={selectDate.fromDate}
                    isClearable
                    placeholderText="To Date"
                  />
                </Box>
              </Box>
</Box>
               <Box sx={{ width: "15%", marginLeft: "82%" }}>
            <BottomNavigation showLabels sx={globalStyles.bottomNavigationExport}>
              <BottomNavigationAction
                label={
                  <Box sx={globalStyles.exportLabel}>
                    {showLoader ? (
                      <>
                        Exporting&nbsp;&nbsp;&nbsp;
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      </>
                    ) : (
                      "Export"
                    )}
                  </Box>
                }
                disabled={exportDisble}
                onClick={handleExport}
              />
            </BottomNavigation>
          </Box>

          {/* Filters Row */}
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              margin: "10px 30px 20px 30px",
            }}
          >
            <Input
              type="search"
              sx={{
                border: "1px solid #2b3f7a",
                borderRadius: "20px",
                padding: "5px 10px",
              }}
              endAdornment={
                <SearchIcon sx={{ cursor: "pointer" }} onClick={handleSearch} />
              }
              placeholder="Search by ID, Email, Phone"
              onChange={(e) => setSearchString(e.target.value)}
            />

            <DatePicker
              selected={selectDate.fromDate}
              onChange={handleFromDateChange}
              selectsStart
              startDate={selectDate.fromDate}
              endDate={selectDate.toDate}
              isClearable
              placeholderText="From Date"
            />
            <DatePicker
              selected={selectDate.toDate}
              onChange={handleToDateChange}
              selectsEnd
              startDate={selectDate.fromDate}
              endDate={selectDate.toDate}
              minDate={selectDate.fromDate}
              isClearable
              placeholderText="To Date"
            />

            <Button
              onClick={handleExport}
              variant="contained"
              sx={{
                textTransform: "none",
                backgroundColor: "primary.main",
                color: "white",
              }}
              disabled={exportDisble}
            >
              {showLoader ? "Exporting..." : "Export"}
            </Button>
          </Box> */}

          {/* Header with search & filters */}
          {/* <Box sx={globalStyles.headerWrapperBox}>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                margin: "0px 30px",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="h4">Corporate Gifting</Typography>
                <Typography
                  variant="subtitle1"
                  sx={globalStyles.headerCountSubtitle}
                >
                  {totalCount} record(s) found
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Input
                  type="search"
                  sx={{
                    border: "1px solid #2b3f7a",
                    borderRadius: "20px",
                    padding: "5px 10px",
                  }}
                  endAdornment={
                    <SearchIcon
                      sx={{ cursor: "pointer" }}
                      onClick={() => handleSearch()}
                    />
                  }
                  placeholder="Search by ID, Email, Phone"
                  onChange={(e) => setSearchString(e.target.value)}
                />

                <DatePicker
                  selected={selectDate.fromDate}
                  onChange={handleFromDateChange}
                  selectsStart
                  startDate={selectDate.fromDate}
                  endDate={selectDate.toDate}
                  isClearable
                  placeholderText="From Date"
                />
                <DatePicker
                  selected={selectDate.toDate}
                  onChange={handleToDateChange}
                  selectsEnd
                  startDate={selectDate.fromDate}
                  endDate={selectDate.toDate}
                  minDate={selectDate.fromDate}
                  isClearable
                  placeholderText="To Date"
                />

                <Button
                  variant="contained"
                  onClick={handleExport}
                  disabled={exportDisble}
                >
                  {showLoader ? "Exporting..." : "Export"}
                </Button>
              </Box>
            </Box>
          </Box> */}

          {/* Table */}
          <TableContainer component={Paper} sx={{ margin: "20px 30px", width: "94%" }}>
            <Table>
              <TableHead
                sx={{
                  backgroundColor: globalStyles.colors.backgroundPrimary,
                  "& .MuiTableCell-root": {
                    color: "#fff",
                    padding: "10px",
                    borderRight: "2px solid #fff",
                  },
                }}
              >
                <TableRow>
                  {allTableHeaders.map(
                    (header) =>
                      header.checked && (
                        <StyledTableCell key={header.id} align="center">
                          {header.label}
                        </StyledTableCell>
                      )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {listData.map((gift) => (
                  <StyledTableRow key={gift._id}>
                    {allTableHeaders.map((header) => {
                      if (!header.checked) return null;
                      let value = gift[header.id];
                      if (header.id === "createdAt" || header.id === "eventDate") {
                        value = formatDate(value);
                      }
                      return (
                        <StyledTableCell key={header.id} align="center">
                          {value || "-"}
                        </StyledTableCell>
                      );
                    })}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Box sx={{ justifyContent: "center" }}>
            <Pagination
              count={Math.ceil(totalCount / 50)}
              page={currentPage}
              onChange={handlePagination}
            />
          </Box>
        </List>
      </Box>
    </React.Fragment>
  );
}


export default CorporateGifting;